import { css } from 'aphrodite';
import * as React from 'react';
import { ResourceCard } from './ResourceCard';
import { s } from './styles';
import { ResourceStatus, ResourceType } from './types';

interface SecondaryResourcesPanelProps {
	primaryType: ResourceType;
	secondaryResources: ResourceStatus[];
	onGenerateResource: (targetType: ResourceType) => void;
}

export const SecondaryResourcesPanel: React.FC<SecondaryResourcesPanelProps> = ({
	primaryType,
	secondaryResources,
	onGenerateResource,
}) => {
	return (
		<div className={css(s.aiCardsContainer)}>
			{secondaryResources.map(resourceStatus => (
				<ResourceCard
					key={resourceStatus.type}
					status={resourceStatus}
					sourceType={primaryType}
					onGenerate={resourceStatus.isCompleted ? undefined : () => onGenerateResource(resourceStatus.type)}
				/>
			))}
		</div>
	);
};
